import React from 'react'
import classes from './Header.module.scss'
 

const Header = () => (
  <header className={classes.container}>
    <h1 className={classes.header}>WeatherHere</h1> 
  </header>
)

export default Header

